import React from 'react';
import {connect} from "react-redux";

const mapStateToProps = (state)=>({products : state.filters.products});

export default connect(mapStateToProps) (({product,handleCheck,products, className})=>{
    const isChecked = products.indexOf(product) >= 0;
    return <form className={className}>
            <label>
                {product}
                <input className='filters--checkbox'
                    type="checkbox"
                    checked={isChecked}
                    onChange={()=>handleCheck(isChecked)} />
            </label>
        </form>
});

